import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiCheckbox } from '@splashthat/sui';
import get from 'lodash/get';

import { getFormNode } from 'common/entities/formNode/selectors';
import { isFormTypeTicketSale } from 'common/entities/form/selectors';
import { getFormId } from 'common/compounds/FormBuilder/selectors';
import { updateFormNodeConfigValue } from '../../../actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

const VALUES_HIDDEN_CHECKBOX_LABEL = 'Response options values are the same as label.';
const HIDE_OPTIONS_NOT_AVAILABLE = 'Hide options when capacity is reached.';
const DISPLAY_LIMITS_LABEL = 'Display remaining responses limits on forms.';

/**
 * This view renders a few controls for dropdown, radio and multi check questions.
 */
const MultiChoiceControls = (props) => (
    <React.Fragment>
        {props.isAllowedResponseLimit && (
            <React.Fragment>
                <SuiCheckbox
                    label={DISPLAY_LIMITS_LABEL}
                    checked={props.showRemainingResponses}
                    disabled={props.disabled}
                    onChange={(event, value) => props.onShowRemainingResponsesChange(value)}
                />
                <SuiCheckbox
                    label={HIDE_OPTIONS_NOT_AVAILABLE}
                    checked={props.hideNotAvailableResponses}
                    disabled={props.disabled}
                    onChange={(event, value) => props.onHideNotAvailableResponsesChange(value)}
                />
            </React.Fragment>
        )}
        <SuiCheckbox
            label={VALUES_HIDDEN_CHECKBOX_LABEL}
            checked={!props.showEditValueInputs}
            disabled={props.disabled}
            onChange={(event, value) => props.onShowEditValueInputsChange(value)}
        />
    </React.Fragment>
);

MultiChoiceControls.propTypes = {
    isAllowedResponseLimit: PropTypes.bool.isRequired,
    showRemainingResponses: PropTypes.bool.isRequired,
    onShowRemainingResponsesChange: PropTypes.func.isRequired,
    hideNotAvailableResponses: PropTypes.bool.isRequired,
    onHideNotAvailableResponsesChange: PropTypes.func.isRequired,
    showEditValueInputs: PropTypes.bool.isRequired,
    onShowEditValueInputsChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formId = getFormId(state);
    const formNode = getFormNode(state, props.formNodeId);

    return {
        isAllowedResponseLimit: !isFormTypeTicketSale(state, formId),

        showRemainingResponses: Boolean(get(formNode, 'config.showRemainingResponses', false)),
        hideNotAvailableResponses: Boolean(get(formNode, 'config.hideNotAvailableResponses', false)),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onShowRemainingResponsesChange: (isChecked) =>
        dispatch(updateFormNodeConfigValue(ownProps.formNodeId, 'showRemainingResponses', isChecked)),
    onHideNotAvailableResponsesChange: (isChecked) =>
        dispatch(updateFormNodeConfigValue(ownProps.formNodeId, 'hideNotAvailableResponses', isChecked)),
});

const ConnectedMultiChoiceControls = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(MultiChoiceControls));

ConnectedMultiChoiceControls.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedMultiChoiceControls.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedMultiChoiceControls;
